import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    ContractBasis,
} from 'app/Apps/Pricing/Pricing.types'

import config from 'app/requests/ContractBasis/ContractBasis.requests'

export default (id, enabled = true) => {
    return useRequest<ContractBasis>({
        key: RequestKeys.getContractBasis,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config.get),
        enabled: Boolean(id) && enabled,
        keepPreviousData: true,
    })
}
